import React, { Component } from 'react'
import { navigate } from '@reach/router'
import Button from 'react-bootstrap/Button'

import { pages, Announcement } from 'types'
import { Page, TextInput } from 'components'
import { QuestionApi, UserApi, AnnouncementApi } from 'api'
import AppStore from 'AppStore'
import { isSuperAdmin } from 'utils/permission'

interface Props {
  path: string
}

interface State {
  count: number
  showEditPassword: boolean
  newPassword: string
  oldPassword?: string
  errorMessage?: string
  announcement?: string
  announcements?: Announcement[]
}

export default class HomePage extends Component<Props, State> {
  state: State = {
    count: 0,
    newPassword: '',
    showEditPassword: false,
  }
  page?: Page

  logOut = async () => {
    try {
      const refreshToken = AppStore.user?.refreshToken!
      await UserApi.logout(refreshToken)
    } catch (e) {}
    await AppStore.clearAsyncStorage()
    await AppStore.changeNotification({ message: 'Logout effettuato correttamente', type: 'success' })
    navigate('/login')
  }

  // TODO da levare password così @gaspa
  changePassword = async () => {
    const { newPassword, oldPassword } = this.state
    if (!oldPassword || !newPassword) {
      this.setState({ errorMessage: 'Scrivi la password' })
      return
    }
    var passw = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,20}$/
    if (!newPassword.match(passw) || newPassword.length < 8) {
      this.setState({
        errorMessage:
          'La password deve essere lunga almeno 8 caratteri e deve contenere almeno un numero e una lettera maiuscola ',
      })
      return
    }
    try {
      await UserApi.changePassword(oldPassword, newPassword)
      await AppStore.clearAsyncStorage()
      this.page?.showConfirmDialog(
        'Password aggiornata',
        'Dovrai effettuare il login con la nuova password',
        this.logOut,
        this.logOut
      )
    } catch (e) {
      this.setState({ errorMessage: 'La password che hai inserito non è corretta' })
    }
  }

  componentDidMount = async () => {
    try {
      const count = await QuestionApi.getQuestionsCount({ author: AppStore.user?._id })
      const announcements = await AnnouncementApi.getAnnouncements()
      this.setState({ count, announcements })
    } catch (error) {}
  }

  createAnnouncement = () => {
    const { announcement } = this.state
    if (announcement && announcement.length > 0) AnnouncementApi.addAnnouncement(announcement)
  }

  render() {
    const { count, showEditPassword, errorMessage, announcements, announcement } = this.state
    const welcomeMessage = `Ciao ${AppStore.user?.name ?? 'autore'}`
    const questions = count > 0 ? 'domande inserite' : 'Nessuna domanda inserita'
    const previous =
      announcements && announcements.length > 0 ? announcements[announcements.length - 1].text : undefined
    return (
      <Page
        ref={(ref) => {
          this.page = ref!
        }}
        page={pages.HOME}
      >
        <div className="sq-dashboard">
          <section className="sq-dashboard__welcome">
            <div>
              <span className="sq-page-header__eyebrow">Workspace autori</span>
              <h1>{welcomeMessage}</h1>
              <p>Qui trovi il punto della situazione e gli strumenti del tuo account.</p>
            </div>
            <div className="sq-dashboard__metric" aria-label={`${count} ${questions}`}>
              <strong>{count}</strong>
              <span>{questions}</span>
            </div>
          </section>

          <div className="sq-dashboard__grid">
            <section className="sq-panel">
              <div className="sq-panel__header">
                <h2>Bacheca annunci</h2>
                <span className="sq-panel__meta">Comunicazioni interne</span>
              </div>
              {isSuperAdmin() ? (
                <>
                  <TextInput
                    placeholder="Scrivi qui il tuo annuncio"
                    value={announcement ?? previous}
                    onChange={(value) => this.setState({ announcement: value })}
                    multiline={true}
                    rows={10}
                  />
                  <Button onClick={this.createAnnouncement}>Salva annuncio</Button>
                </>
              ) : (
                <p style={{ whiteSpace: 'pre-wrap' }}>{previous ?? 'Nessun nuovo annuncio.'}</p>
              )}
            </section>

            <aside className="sq-panel">
              <div className="sq-panel__header"><h2>Account</h2></div>
              <p>Per confrontarti con gli altri autori puoi usare il canale Telegram riservato.</p>
              <a href="https://t.me/joinchat/DJnghBZTwUiDagCFZVNosA" target="_blank" rel="noopener noreferrer">
                Apri Telegram
              </a>
              <div className="sq-panel__actions">
                <Button variant="outline-secondary" onClick={() => this.setState({ showEditPassword: !showEditPassword })}>
                  Modifica password
                </Button>
                <Button variant="outline-secondary" onClick={this.logOut}>Esci</Button>
              </div>
            </aside>
          </div>

          {showEditPassword && (
            <section className="sq-panel" aria-labelledby="password-title">
              <div className="sq-panel__header"><h2 id="password-title">Modifica password</h2></div>
              <div className="sq-password-grid">
                <TextInput label="Password corrente" type="password" onChange={(oldPassword) => this.setState({ oldPassword })} />
                <TextInput label="Nuova password" type="password" onChange={(newPassword) => this.setState({ newPassword })} />
              </div>
              {errorMessage && <p className="sq-form-error" role="alert">{errorMessage}</p>}
              <Button variant="primary" onClick={this.changePassword}>Conferma modifica</Button>
            </section>
          )}
        </div>
      </Page>
    )
  }
}
